import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('google');
const type = createActionType('google');

export const GET_GOOGLE_CREDENTIALS = apiType('GetCredentials');
export const SET_GOOGLE_CREDENTIALS = apiType('SetCredentials');
export const DELETE_GOOGLE_CREDENTIALS = apiType('DeleteCredentials');
export const CANCEL_QUERY = apiType('CancelQuery');
export const TOGGLE_INTEGRATION_UNCONFIGURED_DIALOG = type('ToggleIntegrationUnconfiguredDialog');
